




























import Vue from 'vue'
import iconChevronLeft from '@/assets/svg/rounded/chevron-left.svg?inline'
import iconChevronRight from '@/assets/svg/rounded/chevron-right.svg?inline'
import iconCaretDown from '@/assets/svg/rounded/caret-down.svg?inline'
import {
  DATA_TABLE_SELECT_VALUES,
  DEFAULT_ITEMS_ON_PAGE,
} from '@/constants/dataTable'

interface Props {
  pagination: DataPagination
  tableId: string
  position: string
}

interface Data {
  currentLimit: number
  currentOffset: number
  selectItems: Array<number>
  showSelect: boolean
  defaultLimit: number
  defaultOffset: number
}

interface Computed {
  showedItems: number
  disablePrevBtn: boolean
  disableNextBtn: boolean
  currentOffsetPlusOne: number
}

interface Methods {
  changeCount: (newCount: number) => void
  changePage: (nextPage: number) => void
  setValues: () => void
  toggleSelect: (status: boolean) => void
}

export interface DataPagination {
  offset: number
  limit: number
  total: number
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    iconCaretDown,
    iconChevronRight,
    iconChevronLeft,
  },
  props: {
    pagination: {
      required: true,
    },
    tableId: {
      required: false,
      default: '',
    },
    position: {
      required: false,
      default: 'top',
    }
  },
  data() {
    return {
      defaultLimit: DEFAULT_ITEMS_ON_PAGE,
      showSelect: false,
      currentLimit: DEFAULT_ITEMS_ON_PAGE,
      currentOffset: 0,
      selectItems: DATA_TABLE_SELECT_VALUES,
      defaultOffset: 0,
    }
  },
  computed: {
    showedItems() {
      if (
        this.pagination &&
        this.pagination.total - this.currentOffset - this.currentLimit < 0
      ) {
        return this.pagination.total
      }
      if (
        this.pagination &&
        !(this.pagination.total - this.currentOffset - this.currentLimit < 0)
      ) {
        return this.currentOffset + Number(this.currentLimit)
      }
      return 0
    },
    currentOffsetPlusOne() {
      if (this.pagination.total === 0) {
        return 0
      } else {
        return this.currentOffset + 1
      }
    },
    disablePrevBtn() {
      const newOffset = this.currentOffset - this.currentLimit
      return newOffset < 0
    },
    disableNextBtn() {
      const newOffset = this.currentOffset + this.currentLimit
      return this.pagination.total - newOffset <= 0
    },
  },
  methods: {
    toggleSelect(status) {
      this.showSelect = status
    },
    changeCount(newCount: number) {
      this.currentLimit = newCount
      this.currentOffset = 0
      const query = Object.assign({}, this.$route.query)
      if (this.currentLimit !== DEFAULT_ITEMS_ON_PAGE) {
        query[`limit${this.tableId}`] = String(newCount)
      } else {
        delete query[`limit${this.tableId}`]
      }
      delete query[`offset${this.tableId}`]
      if (query[`limit${this.tableId}`] !== this.$route.query[`limit${this.tableId}`]) {
        this.$router.replace({ query })
      }
    },
    changePage(nextPage) {
      this.currentOffset = this.currentOffset + this.currentLimit * nextPage
      this.$router.push({
        query: { ...this.$route.query, [`offset${this.tableId}`]: String(this.currentOffset) },
      })
      if (this.currentOffset === 0) {
        const query = Object.assign({}, this.$route.query)
        delete query[`offset${this.tableId}`]
        this.$router.replace({ query })
      }
    },
    setValues() {
      if (
        this.$route.query[`limit${this.tableId}`] &&
        Number.isInteger(+this.$route.query[`limit${this.tableId}`])
      ) {
        this.currentLimit = Number(this.$route.query[`limit${this.tableId}`])
      } else {
        this.currentLimit = Number(this.defaultLimit)
      }
      if (
        this.$route.query[`offset${this.tableId}`] &&
        Number.isInteger(+this.$route.query[`offset${this.tableId}`])
      ) {
        this.currentOffset = Number(this.$route.query[`offset${this.tableId}`])
      } else {
        this.currentOffset = Number(this.defaultOffset)
      }
    },
  },
  mounted() {
    this.setValues()
  },
  watch: {
    '$route.query'(oldValue, newValue) {
      if(oldValue[`limit${this.tableId}`] !== newValue[`limit${this.tableId}`]){
        this.setValues()
      }
      if(oldValue[`offset${this.tableId}`] !== newValue[`offset${this.tableId}`]){
        this.setValues()
      }
    },
  },
})
